import { apiRequest } from './httpClient';

// Dashboard query endpoints mostly return legacy payloads directly; data fetches support AbortController via signal.

export async function checkHealth() {
    await apiRequest('/health');
    return true;
}

export async function fetchTables() {
    return apiRequest('/tables');
}

export async function fetchAccessData({ selectedTable, searchTerm, originFilter, countryFilter, limit = 1000, offset = 0, signal }) {
    const params = new URLSearchParams({
        limit: String(limit),
        offset: String(offset)
    });

    if (searchTerm && searchTerm.trim()) {
        params.append('searchOriginMessage', searchTerm.trim());
    }
    if (originFilter && originFilter !== 'All Origins') {
        params.append('origin', originFilter);
    }
    if (countryFilter && countryFilter !== 'All Countries') {
        params.append('destination', countryFilter);
    }

    return apiRequest(`/data/${selectedTable}?${params.toString()}`, { signal });
}

export async function fetchTableStats(selectedTable) {
    const data = await apiRequest(`/stats/${selectedTable}`);
    return {
        total: data.totalRecords || 0,
        origins: data.uniqueOrigins || 0
    };
}

export async function fetchFilterOptions(selectedTable, options = {}) {
    const [originsResult, destinationsResult] = await Promise.all([
        apiRequest(`/filters/${selectedTable}?field=origin&limit=5000`, options),
        apiRequest(`/filters/${selectedTable}?field=destination&limit=5000`, options)
    ]);

    return {
        origins: Array.isArray(originsResult.values) ? originsResult.values : [],
        destinations: Array.isArray(destinationsResult.values) ? destinationsResult.values : []
    };
}
